import { makeDecorator } from "@storybook/preview-api";
import { ReactNode } from "react";
import Div100vh from "react-div-100vh";
import { ConfiguratorHeader, ConfiguratorStepper } from "src/pages/configurator/components";
import { ConfiguratorProvider } from "src/pages/configurator/Configurator.context";
import { Css } from "~generated/css";

// Mostly duplicates the layout Configurator.layout gives us without needing the extra
export const configuratorContextFullDecorator = makeDecorator({
  name: "configuratorContextFull",
  parameterName: "configuratorContextFull",
  wrapper: (storyFn, context, settings) => {
    const noStepper = settings?.parameters?.noStepper ?? false;
    return (
        <div css={Css.df.fdc.bgWhite.oh.h100.$}>
          <ConfiguratorProvider>
            <ConfiguratorHeader />
            {storyFn(context) as ReactNode}
            {/* Note: We're iterating this. For now `PlanStep` will use its own stepper */}
            {!noStepper && <ConfiguratorStepper />}
          </ConfiguratorProvider>
        </div>
    );
  },
});
